/**
 * @file 新闻详情页
 * @author wanzhongyun
 */

import React from 'react';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/Footer';

import useNewsDetailStore from './NewsDetailHooks';

const News: React.FC = () => {
    const {
        title,
        pubTime,
        pv,
        content,
        preNews,
        nextNews,
        // relations
    } = useNewsDetailStore();

    return (
        <div className="page paddle-news-detail-page">
            <Header />
            <div className="paddle-news-detail-page-container">

                <div className="ai-newscdetail">
                    <div className="ai-newscdetail-main">
                        <div className="ai-newscdetail-title">
                            {title}
                        </div>

                        <div className="ai-newscdetail-info-container">
                            <span
                                className="ai-newscdetail-time">
                                Date：{pubTime}
                            </span>
                            <span>PV: {pv}</span>
                            <div
                                className="ai-newscdetail-content"
                                {...{dangerouslySetInnerHTML:{__html: content}}}
                            />
                            <div className="ai-newscdetail-pagination">
                                {
                                    !!preNews
                                    && <div className="ai-newscdetail-previous">
                                        Previous：<a href={preNews.link}>
                                        {preNews.title}
                                    </a>
                                    </div>
                                }
                                {
                                    !!nextNews
                                    && <div className="ai-newscdetail-next">
                                        Next：<a href={nextNews.link}>
                                        {nextNews.title}
                                    </a>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                    {/* <div className="ai-newscdetail-recommend">
                        <div className="ai-newscdetail-recommend-title">Related News</div>
                        {relations.map(news => (
                            <div
                                className="ai-newscdetail-recommend-item"
                                key={news.id}
                            >
                                <a href={news.link}>{news.title}</a>
                            </div>
                        ))}
                    </div> */}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default News;
